import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Broadcast } from 'src/app/core/services/broadcast.service';
import { DemandeRecrutement } from '@models/domains/recruitment';
import { ModifyRecruitmentRequest } from '@models/api/requests';
import { ValidationDetail } from '@models/shared';
import { FileAttachment } from '@models/shared';
import { HttpParamsUtils } from '../../shared/utils/http-params-utils';

@Injectable({
  providedIn: 'root'
})
export class DemandeRecrutementService {
  private module = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(
    private readonly http: HttpClient,
    private readonly broadcast: Broadcast
  ) {}

  createDemandeRecrutement(demandeRecrutement: any, piecesJointes: File[]): Observable<any> {
    const formdata = new FormData();
    formdata.append('demandeRecrutement', JSON.stringify(demandeRecrutement));
    piecesJointes.forEach((file, index) => {
      formdata.append(`piecesJointes`, file);
    });
    return this.http.post<any>(`${this.module}/demandes-recrutement`, formdata);
  }

  getDemandesWithId(data: any, id: number) {
    return this.http.put<any>(`${this.module}/demandes-recrutement/${id}`, data);
  }

  getDemandes() {
    return this.http.get<any>(this.module + '/demandes');
  }

  getDemandesWithParams(offset: number, limit: number, filters?: Record<string, any>) {
    let params = new HttpParams().set('page', offset).set('size', limit);
    params = HttpParamsUtils.addFilterParams(params, filters);
    return this.http.get<any>(`${this.module}/demandes`, { params });
  }

  //Récupérer les détails d'une demande de recrutement par ID.
  getDemandesRecrutementById(id: string): Observable<DemandeRecrutement> {
    return this.http.get<DemandeRecrutement>(this.module + '/demandes-recrutement/' + id);
  }
  //Récupérer les détails d'une demande de recrutement par ID.
  getDetailsValidations(id: string, typeDemande: string): Observable<ValidationDetail[]> {
    return this.http.get<ValidationDetail[]>(`${this.module}/demandes/${id}/details-validations/${typeDemande}`);
  }

  modifierDemandesRecrutement(data: ModifyRecruitmentRequest): Observable<DemandeRecrutement> {
    return this.http.put<DemandeRecrutement>(`${this.module}/demandes-recrutement/${data.id}`, data);
  }

  deleteDemandesRecrutement(id: string) {
    return this.http.delete(`${this.module}/demandes-recrutement/${id}`);
  }

  getAgentConnecte(): Observable<any> {
    return this.http.get<any>(`${this.module}/agents/moi`);
  }

  getPj(id: string): Observable<FileAttachment[]> {
    return this.http.get<FileAttachment[]>(`${this.module}/demandes-recrutement/pieces-jointes/${id}`);
  }

  postPj(id: string, piecesJointes: File[]): Observable<FileAttachment[]> {
    const formdata = new FormData();
    piecesJointes.forEach((file) => {
      formdata.append(`pieceJointe`, file);
    });
    return this.http.post<any>(`${this.module}/demandes-recrutement/pieces-jointes/${id}`, formdata);
  }

  deletePj(id: string, idPj: string): Observable<FileAttachment[]> {
    return this.http.delete<FileAttachment[]>(`${this.module}/demandes-recrutement/pieces-jointes/${id}/${idPj}`);
  }
}
